const API_BASE = "";

// 🔧 API base instellen (werkt lokaal en in productie)
// const API_BASE = window.location.hostname === "localhost"
//   ? "http://localhost:4000"
//   : "";

const fetchOptions = { credentials: "include" }; // 🔥 stuurt adminToken-cookie mee

// 📄 HTML genereren
export function adminDashboard() {
  return `
    <div id="admin-dashboard" class="p-6 space-y-6 min-h-screen bg-gray-50">
      <div class="flex items-center justify-between mb-6">
        <h1 class="text-3xl font-bold">Admin Dashboard</h1>
        <button id="admin-logout" class="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700">
          Uitloggen
        </button>
      </div>

      <!-- Stats -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="bg-white shadow rounded-2xl p-4 flex items-center justify-between border border-gray-200">
          <div>
            <p class="text-gray-500 text-sm">Totaal gebruikers</p>
            <p id="total-users" class="text-2xl font-semibold text-gray-800">...</p>
          </div>
          <div class="bg-blue-100 p-3 rounded-full">
            <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5V8h-5M2 20h5V4H2m10 16h5V12h-5" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Gebruikers tabel -->
      <div class="bg-white shadow rounded-2xl p-6 border border-gray-200">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-xl font-semibold">Gebruikersbeheer</h2>
          <button id="add-user" class="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700">
            ➕ Nieuwe gebruiker
          </button>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full text-left border-collapse">
            <thead class="bg-gray-100 text-gray-600">
              <tr>
                <th class="py-2 px-4 border-b">Naam</th>
                <th class="py-2 px-4 border-b">Email</th>
                <th class="py-2 px-4 border-b">Rol</th>
                <th class="py-2 px-4 border-b text-center">Acties</th>
              </tr>
            </thead>
            <tbody id="user-table" class="text-gray-800">
              <tr><td colspan="4" class="py-3 text-gray-500 text-center">Laden...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;
}

// ⚙️ Data ophalen en DOM vullen
export async function initAdminDashboard() {

  // 🛡 ADMIN-CHECK VIA COOKIE
  const resCheck = await fetch(`${API_BASE}/api/checkAdminAuth`, {
    method: "GET",
    credentials: "include"
  });

  if (resCheck.status === 401) {
    // Verberg dashboard en redirect naar /register/
    const dash = document.getElementById("admin-dashboard");
    if (dash) dash.classList.add("hidden");
    window.location.href = "/register/";
    return;
  }

  const table = document.getElementById("user-table");
  const totalUsersEl = document.getElementById("total-users");
  const logoutBtn = document.getElementById("admin-logout");
  const addUserBtn = document.getElementById("add-user");

  if (!table || !totalUsersEl) return;

  // ✅ Uitloggen
  logoutBtn.addEventListener("click", async () => {
    try {
      const res = await fetch(`${API_BASE}/api/logoutAdmin`, {
        method: "POST",
        credentials: "include"
      });

      if (!res.ok) throw new Error("Fout bij uitloggen");

      // Cookie wordt door backend verwijderd
      window.location.href = "/portaal/adminlogin";

    } catch (err) {
      console.error("Fout bij uitloggen:", err);
      alert("❌ Uitloggen mislukt.");
    }
  });

  // ➕ NIEUWE GEBRUIKER
  addUserBtn.addEventListener("click", () => {
    const modal = document.createElement("div");
    modal.innerHTML = `
      <div id="add-user-modal" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl shadow-lg p-8 w-full max-w-md relative">
          <button id="close-add-modal" class="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl">&times;</button>
          <h3 class="text-lg font-semibold mb-4">Nieuwe gebruiker toevoegen</h3>
          <form id="add-user-form" class="space-y-4">
            <div>
              <label class="block text-sm font-medium mb-1">Naam</label>
              <input type="text" name="name" class="w-full border rounded px-3 py-2" required />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1">Email</label>
              <input type="email" name="email" class="w-full border rounded px-3 py-2" required />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1">Wachtwoord</label>
              <input type="password" name="password" class="w-full border rounded px-3 py-2" required />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1">Rol</label>
              <select name="role" class="w-full border rounded px-3 py-2" required>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <button type="submit" class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 w-full">Toevoegen</button>
          </form>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    // Sluit modal
    modal.querySelector("#close-add-modal").onclick = () => modal.remove();

    // Formulier submit
    modal.querySelector("#add-user-form").onsubmit = async (ev) => {
      ev.preventDefault();
      const form = ev.target;
      const name = form.name.value;
      const email = form.email.value;
      const password = form.password.value;
      const role = form.role.value;

      if (!name || !email || !password || !role) {
        alert("Alle velden zijn verplicht.");
        return;
      }

      try {
        const res = await fetch(`${API_BASE}/api/add-user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name, email, password, role }),
          credentials: "include"
        });

        if (!res.ok) throw new Error("Fout bij toevoegen gebruiker");
        alert("✅ Gebruiker toegevoegd!");
        modal.remove();
        initAdminDashboard();

      } catch (err) {
        console.error(err);
        alert("❌ Fout bij toevoegen gebruiker.");
      }
    };
  });

  // 📦 GEBRUIKERSOPHAAL
  try {
    const res = await fetch(`${API_BASE}/api/adminDashboard`, {
      method: "GET",
      credentials: "include"
    });

    if (!res.ok) throw new Error("Fout bij ophalen dashboard");

    const data = await res.json();
    totalUsersEl.textContent = data.totalUsers ?? "—";
    table.innerHTML = "";

    if (!data.users?.length) {
      table.innerHTML = `<tr><td colspan="4" class="py-3 text-gray-500 text-center">Geen gebruikers gevonden</td></tr>`;
      return;
    }

    data.users.forEach((user) => {
      const tr = document.createElement("tr");
      tr.innerHTML = `
        <td class="py-2 px-4 border-b">${user.name}</td>
        <td class="py-2 px-4 border-b">${user.email}</td>
        <td class="py-2 px-4 border-b">${user.role}</td>
        <td class="py-2 px-4 border-b text-center space-x-2">
          <button data-action="update" data-id="${user.id}" class="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700">Bewerk</button>
          <button data-action="block" data-id="${user.id}" class="bg-yellow-600 text-white px-3 py-1 rounded text-sm hover:bg-yellow-700">${user.isBlock ? "Deblokkeer" : "Blokkeer"}</button>
          <button data-action="delete" data-id="${user.id}" class="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700">Verwijder</button>
        </td>
      `;
      table.appendChild(tr);
    });

    // 🛠 GEBRUIKERS-ACTIES
    table.addEventListener("click", async (e) => {
      const btn = e.target.closest("button[data-action]");
      if (!btn) return;

      const userId = btn.dataset.id;
      const action = btn.dataset.action;

      // ✏️ Update gebruiker
        if (action === "update") {
          // Zoek de huidige gebruiker data
          const user = data.users.find(u => u.id == userId);
          // Maak een modal aan
          const modal = document.createElement("div");
          modal.innerHTML = `
            <div id="update-user-modal" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div class="bg-white rounded-xl shadow-lg p-8 w-full max-w-md relative">
                <button id="close-update-modal" class="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl">&times;</button>
                <h3 class="text-lg font-semibold mb-4">Update gebruiker</h3>
                <form id="update-user-form" class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium mb-1">Naam</label>
                    <input type="text" name="name" value="${user.name}" class="w-full border rounded px-3 py-2" required />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1">Email</label>
                    <input type="email" name="email" value="${user.email}" class="w-full border rounded px-3 py-2" required />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1">Rol</label>
                    <select name="role" class="w-full border rounded px-3 py-2" required>
                      <option value="user" ${user.role === "user" ? "selected" : ""}>User</option>
                      <option value="admin" ${user.role === "admin" ? "selected" : ""}>Admin</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1">Wachtwoord</label>
                    <input type="password" name="password" placeholder="Nieuw wachtwoord (optioneel)" class="w-full border rounded px-3 py-2" />
                  </div>
                  <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full">Opslaan</button>
                </form>
              </div>
            </div>
          `;
          document.body.appendChild(modal);

          // Sluit modal
          modal.querySelector("#close-update-modal").onclick = () => modal.remove();

          // Formulier submit
          modal.querySelector("#update-user-form").onsubmit = async (ev) => {
            ev.preventDefault();
            const form = ev.target;
            const name = form.name.value;
            const email = form.email.value;
            const role = form.role.value;
            const password = form.password.value;

            if (!name || !email || !role) {
              alert("Naam, email en rol zijn verplicht.");
              return;
            }

            try {
              const res = await fetch(`${API_BASE}/api/update-user`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: userId, name, email, role, password: password || undefined }),
                credentials: "include"
              });

              if (!res.ok) throw new Error("Fout bij bijwerken gebruiker");
              alert("✅ Gebruiker bijgewerkt.");
              modal.remove();
              initAdminDashboard();

            } catch (err) {
              console.error(err);
              alert("❌ Fout bij bijwerken gebruiker.");
            }
          };
        }

      // ⛔ Blokkeren / deblokkeren
      if (action === "block") {
        const confirmAction = confirm("Weet je zeker dat je deze gebruiker wilt blokkeren/deblokkeren?");
        if (!confirmAction) return;

        try {
          const res = await fetch(`${API_BASE}/block-user/${userId}`, {
            method: "POST",
            credentials: "include"
          });

          if (!res.ok) throw new Error("Fout bij blokkeren gebruiker");
          alert("✅ Gebruikerstatus aangepast.");
          initAdminDashboard();

        } catch (err) {
          console.error(err);
          alert("❌ Fout bij blokkeren gebruiker.");
        }
      }

      // 🗑️ Verwijderen
      if (action === "delete") {
        const confirmDel = confirm("⚠️ Weet je zeker dat je deze gebruiker wilt verwijderen?");
        if (!confirmDel) return;

        try {
          const res = await fetch(`${API_BASE}/api/delete-user`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: userId }),
            credentials: "include"
          });

          if (!res.ok) throw new Error("Fout bij verwijderen gebruiker");
          alert("🗑️ Gebruiker verwijderd.");
          initAdminDashboard();

        } catch (err) {
          console.error(err);
          alert("❌ Fout bij verwijderen gebruiker.");
        }
      }
    });

  } catch (err) {
    console.error("Fout bij ophalen dashboard:", err);
    table.innerHTML = `
      <tr><td colspan="4" class="py-3 text-red-500 text-center">Kon gebruikers niet laden</td></tr>`;
  }
}
